import { SET_FAVOURITE_ORDER, GET_ORDER_HISTORY, GET_ACTIVE_ORDER_HISTORY, DELETE_FAVOURITE_ORDER, RESET_ORDER_HISTORY, RESET_ACTIVE_ORDER_HISTORY, HIDE_OCCASION_TOAST, } from '../../constants';
export function addFavOrder(payload, postBody, successCallback = null, errorCallback = null) {
    return {
        type: SET_FAVOURITE_ORDER,
        payload,
        postBody,
        successCallback,
        errorCallback,
    };
}
export function resetOrderHistory() {
    return {
        type: RESET_ORDER_HISTORY,
    };
}
export function hideFavouriteToastAction() {
    return {
        type: HIDE_OCCASION_TOAST,
    };
}
export function deleteFavOrder({ tenantId, customerId, itemId }, successCallback = null, errorCallback = null) {
    return {
        type: DELETE_FAVOURITE_ORDER,
        payload: { tenantId, customerId, itemId },
        successCallback,
        errorCallback,
    };
}
export function getOrderHistory(payload, postBody, successCallback = null, errorCallback = null) {
    return {
        type: GET_ORDER_HISTORY,
        payload,
        postBody,
        successCallback,
        errorCallback,
    };
}
export function getActiveOrderHistory(payload, postBody, successCallback = null, errorCallback = null) {
    return {
        type: GET_ACTIVE_ORDER_HISTORY,
        payload,
        postBody,
        successCallback,
        errorCallback,
    };
}
export function resetActiveOrderHistory() {
    return {
        type: RESET_ACTIVE_ORDER_HISTORY,
    };
}
